"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var client_exports = {};
__export(client_exports, {
  getClient: () => getClient
});
module.exports = __toCommonJS(client_exports);
var import_core = require("@hcengineering/core");
var import_utils = require("./utils");
function getClient(workspaceId, token, collaboratorUrl) {
  const url = collaboratorUrl.replaceAll("wss://", "https://").replace("ws://", "http://");
  return new CollaboratorClientImpl(workspaceId, token, url);
}
__name(getClient, "getClient");
class CollaboratorClientImpl {
  constructor(workspace, token, collaboratorUrl) {
    this.workspace = workspace;
    this.token = token;
    this.collaboratorUrl = collaboratorUrl;
  }
  static {
    __name(this, "CollaboratorClientImpl");
  }
  async rpc(document, method, payload) {
    const workspace = this.workspace;
    const documentId = (0, import_utils.encodeDocumentId)(workspace, document);
    const url = (0, import_core.concatLink)(this.collaboratorUrl, `/rpc/${encodeURIComponent(documentId)}`);
    const res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ method, payload })
    });
    if (!res.ok) {
      throw new CollaboratorHttpError(res.status);
    }
    const result = await res.json();
    if (result.error != null) {
      throw new Error(result.error);
    }
    return result;
  }
  async getMarkup(document, source) {
    const payload = {
      source: source !== null ? source : void 0
    };
    const res = await retry(async () => {
      return await this.rpc(document, "getContent", payload);
    });
    return res.content[document.objectAttr] ?? "";
  }
  async createMarkup(document, markup) {
    const content = {
      [document.objectAttr]: markup
    };
    const res = await retry(async () => {
      return await this.rpc(document, "createContent", { content });
    });
    return res.content[document.objectAttr];
  }
  async updateMarkup(document, markup) {
    const content = {
      [document.objectAttr]: markup
    };
    await retry(async () => {
      await this.rpc(document, "updateContent", { content });
    });
  }
  async copyContent(source, target, content) {
    const markup = await this.getMarkup(source, content);
    await this.updateMarkup(target, markup);
  }
}
class CollaboratorHttpError extends Error {
  constructor(status) {
    super("HTTP error " + status);
    this.status = status;
  }
  static {
    __name(this, "CollaboratorHttpError");
  }
}
async function retry(op) {
  for (let attempt = 0; ; attempt++) {
    try {
      return await op();
    } catch (error) {
      if (attempt >= 6 || error instanceof CollaboratorHttpError && ![429, 502, 503, 504].includes(error.status)) {
        throw error;
      }
      const delay = Math.min(250 * 2 ** attempt, 2e3) + Math.floor(Math.random() * 100);
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
  }
}
__name(retry, "retry");
//# sourceMappingURL=client.js.map
